<div class="confirmBox boxNoFill lighterBox pricingBox" [class.discountPadding]="discountApplied == true">
    <div class="confirmIcon"><img src="assets/img/{{ clientID }}/home/tradetypes/{{ jobDataService.trade.icon }}" /></div>
    <div class="confirmInfo">
    <div class="confirmTitle" [class.uppercaseLabel]="jobDataService.trade.name == 'HVAC'">{{ jobDataService.trade.name.toUpperCase() }}</div>
    
    <div class="jobTypeInfoContainer" *ngFor="let jobType of jobDataService.jobTypes">
        <div class="confirmSubTitle">{{ jobType.name }}</div>

        <div class="confirmAnswer" *ngIf="!metaDataService.IsAAHomeInspection(jobDataService.trade.id)">
            <div class="confirmAnswerText">Quantity:</div>
            <div class="confirmAnswerEdit">x{{ jobType.currentQuantity }} ({{ jobType.estimatedDuration }}hrs)</div>
            <div style="clear: both;"></div>
        </div>

        <div *ngIf="pricingInfoEnabled" class="confirmAnswer">
            <div class="confirmAnswerText">Estimate:</div>
            <div class="confirmAnswerEdit">{{ '$' + jobType.estimatedFullPrice.toFixed(2) }}</div>
            <div style="clear: both;"></div>
            </div>
        </div>

        <div class="confirmSubTitle" *ngIf="!metaDataService.IsAAHomeInspection(jobDataService.trade.id)">Total Estimated Duration: {{ estimatedDuration }}hrs</div>

    </div>
    <div *ngIf="pricingInfoEnabled" style="clear: both;"></div>
    <div *ngIf="!pricingInfoEnabled" style="padding-bottom: 10px;"></div>

    <div *ngIf="pricingInfoEnabled" class="confirmPrice">
        <div *ngIf="discountApplied == true">
            <div class="confirmPriceTitle">
            {{ jobDataService.trade.id == tradeTypes.HomeInspections ? 'TOTAL PRICE' : 'ESTIMATED PRICE' }}
            </div>
            <div class="confirmPriceText" style="text-decoration: line-through;">{{ '$' + fullPrice.toFixed(2) }}
            </div>
            <div style="clear: both;"></div>

            <div class="confirmPriceTitle">{{ discountText }}</div>
            <div class="confirmPriceText">{{ '$' + currentPrice.toFixed(2) }}</div>
            <div style="clear: both;"></div>
        </div>

        <div *ngIf="discountApplied == false">
            <div class="confirmPriceTitle">
            {{ jobDataService.trade.id == tradeTypes.HomeInspections ? 'TOTAL PRICE' : 'ESTIMATED PRICE' }}
            </div>
            <div class="confirmPriceText">{{ '$' + currentPrice.toFixed(2) }}</div>
            <div style="clear: both;"></div>
        </div>

        <div class="pricingDisclaimer">
            <span *ngIf="clientID != clients.AANZ">All prices include GST.</span>
            <span *ngIf="clientID == clients.AANZ">All prices include GST and a $34.50 Administration fee. Note: There is a minimum charge for all job bookings of one hours labour. Administration fee does not apply to home inspections. </span>
            <span *ngIf="outOfHoursPriceApplied"> An out of hours rate has been applied to this booking.</span>
        </div>
        <div class="pricingDisclaimer" *ngIf="clientID == clients.AANZ">
            * AA Members, AA Insurance policy holders, AA Home Response and AA Home Response Plus subscribers, all receive up to 10% discount.
        </div>
    </div>
</div>

<div *ngIf="bookingWindowsEnabled == true" class="confirmBox boxNoFill lighterBox">
    <div class="confirmIcon"><img
        src="assets/img/{{ clientID }}/icons/calendar_green.png" /></div>
    <div class="confirmInfo">
    <div class="confirmTitle">PREFERRED BOOKING</div>
    <div class="confirmSubTitle">Booking Option One</div>
    <div class="confirmAnswer">
        <div class="confirmAnswerText">
            {{ bookingWindows[0].date == null ? '' : (bookingWindows[0].date | date: 'dd  /  MM  /  yyyy') + ' ' + bookingWindows[0].time.from }}
        </div>
        <div class="confirmAnswerEdit editButton buttonPointer" (click)="goToStepType(2)">edit</div>
        <div style="clear: both;"></div>
    </div>
    <div class="confirmSubTitle">Booking Option Two</div>
    <div class="confirmAnswer">
        <div class="confirmAnswerText">
        {{ bookingWindows[1].date == null ? '' : (bookingWindows[1].date | date: 'dd  /  MM  /  yyyy') + ' ' + bookingWindows[1].time.from }}
        </div>
        <div class="confirmAnswerEdit editButton buttonPointer" (click)="goToStepType(2)">edit</div>
        <div style="clear: both;"></div>
    </div>
    </div>
    <div style="clear: both;"></div>
</div>

<div class="confirmBox boxNoFill lighterBox">
    <div class="confirmIcon"><img
        src="assets/img/{{ clientID }}/icons/contactdetails.png" /></div>
    <div class="confirmInfo">
    <div class="confirmTitle">CONTACT DETAILS</div>
    <div class="confirmSubTitle">Booking Details</div>
    <div class="confirmAnswer">
        <div class="confirmAnswerText">
        {{ jobDataService.jobData.customerContact.contactName }}<br />
        {{ jobDataService.jobData.streetUnit.length > 0 ? jobDataService.jobData.streetUnit + '/' : '' }}{{ jobDataService.jobData.streetAddress }}&nbsp;{{ jobDataService.jobData.suburbName }}&nbsp;{{ jobDataService.jobData.postcode }}<br />
        {{ jobDataService.jobData.customerContact.contactEmail }}<br />
        {{ jobDataService.jobData.customerContact.contactPhone }}
        </div>
        <div class="confirmAnswerEdit editButton buttonPointer" (click)="goToStepType(3)">edit</div>
    </div>
    </div>
    <div style="clear: both;"></div>
</div>